import React from "react";
import Driversettingsheader from "../../components/Drivers/general/Driversettingsheader";


const DriverSettingsMasterLayout = ({children,screenName, centered = true}) => {
    return(
        <>
        <Driversettingsheader screenName={screenName} centered={centered}/>
        {children}
        </>
    );
};
export default DriverSettingsMasterLayout;